exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-nfc[data-v-0034b0fb]{border-radius:.42667rem;background:#fff;height:9.38667rem;text-align:center;padding:.42667rem}@keyframes rotateX-0034b0fb{0%{transform:rotateX(0deg);margin-top:1.6rem}50%{transform:rotateX(40deg);margin-top:.8rem}to{transform:rotateX(0deg);margin-top:1.6rem}}.rotate-x[data-v-0034b0fb]{animation:rotateX-0034b0fb 2s ease-in-out infinite}.nfc-anim[data-v-0034b0fb]{animation:rotateX-0034b0fb 2.5s ease-in-out infinite}", ""]);

// exports
